@if ({}; as STATE) {
  <section class="user-ads-layout"></section>
}
